import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { X, CircleUser } from 'lucide-react';

export default function UserMenuModal({
  open,
  onClose,
  onEditProfile,
  user, // opcional: { name, email, avatarUrl }
}) {
  const boxRef = useRef(null);

  // Fechar no ESC + foco + travar scroll
  useEffect(() => {
    if (!open) return;
    const handleKey = (e) => e.key === 'Escape' && onClose?.();
    document.addEventListener('keydown', handleKey);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    boxRef.current?.setAttribute('tabindex', '-1');
    boxRef.current?.focus();

    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        className="modal-content modal--user"
        role="dialog"
        aria-modal="true"
        aria-labelledby="user-menu-title"
        onClick={(e) => e.stopPropagation()}
        ref={boxRef}
      >
        <div className="modal-header">
          <h3 id="user-menu-title" className="modal-title">Sua conta</h3>
          <button
            aria-label="Fechar"
            className="modal-icon-button"
            onClick={onClose}
          >
            <X className="icon" />
          </button>
        </div>

        <div className="user-menu__profile">
          {user?.avatarUrl ? (
            <img src={user.avatarUrl} alt="Avatar" className="user-menu__avatar" />
          ) : (
            <CircleUser className="user-menu__avatar user-menu__avatar--icon" />
          )}
          <div className="user-menu__meta">
            <div className="user-menu__name">{user?.name || 'Usuário'}</div>
            {user?.email && <div className="user-menu__email">{user.email}</div>}
          </div>
        </div>

        <div className="user-menu__actions">
          {onEditProfile && (
            <button type="button" onClick={onEditProfile} className="modal-close-button">
              <CircleUser className="icon" />
              <span>Editar perfil</span>
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
